import {
  Col,
  Row,
  Space,
  Table,
  Tag,
  Card,
  Button,
  message,
  Spin,
  Input,
  Select,
  Tooltip,
} from "antd";
import { useEffect, useMemo, useState } from "react";
import {
  ReloadOutlined,
  FilterOutlined,
  EditOutlined,
  SearchOutlined,
  DownSquareOutlined,
  UpSquareOutlined,
  FileSearchOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import MotionHoc from "../../../utils/MotionHoc";
import { HEADERS_EXPORT_BEN, POST_CHECK_DOC } from "../../API/apiUrls";

import axios from "axios";
import dayjs from "dayjs";
import { ThaiRangePicker } from "../../../hook/ThaiDatePicker";
import CheckingDocuments from "./modal/CheckingDocuments";
import MemoCheckDoc from "./modal/MemoCheckDoc";
import { generateLawsuitListPDF } from "./report/CheckDocPDF";
import DateCustom from "../../../hook/DateCustom";

const Main = () => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [convertDateThai, convertDateThaiShort] = DateCustom();

  const [arrayTable, setArrayTable] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInputTable, setSearchInputTable] = useState(null);
  const [dataRecord, setDataRecord] = useState();
  const [isModalCheckDoc, setIsModalCheckDoc] = useState(false);
  const [isModalMemoCheckDoc, setIsModalMemoCheckDoc] = useState(false);
  const [searchSelect, setSearchSelect] = useState(1);
  const [titelColumn, setTitelColumn] = useState(1);
  const [advanceSearch, setAdvanceSearch] = useState(false);
  const [datePickerTable, setDatePickerTable] = useState(null);
  const [arrow, setArrow] = useState("Show");
  const toggle = () => setAdvanceSearch((v) => !v);
  const { Option } = Select;

  const loadMainData = async (searchData) => {
    try {
      await axios
        .post(POST_CHECK_DOC, searchData, {
          headers: HEADERS_EXPORT_BEN,
        })
        .then(async (res) => {
          let i = 1;
          if (res.status === 200) {
            if (res.data.success === "ไม่พบข้อมูล") {
              message.warning("ไม่พบข้อมูล");
              return;
            }
            const newData = res?.data.map((item) => ({
              ...item,
              key: i++,
            }));
            filterData(newData);
          } else {
            message.error("ไม่มีข้อมูล");
            setArrayTable([]);
            setDataArr([]);
          }
          console.log("res Role", res.data);
        })
        .catch((err) => {
          console.log("ไม่มีข้อมูล", err); // ถ้ามีข้อผิดพลาดอื่น ๆ ให้แสดงข้อความนี้
          setArrayTable([]);
          setDataArr([]);
        });
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const renderOpteionSearch = () => {
    return (
      <>
        <Option value={1}>
          <span style={{ marginRight: 8 }}>📥</span>
          รอรับงาน
        </Option>
        <Option value={2}>
          <span style={{ marginRight: 8 }}>📝</span>รอดำเนินการ
        </Option>
        <Option value={3}>
          <span style={{ marginRight: 8 }}>✅</span>เตรียมเอกสารเสร็จสิ้น
        </Option>
        <Option value={6}>
          <span style={{ marginRight: 8 }}>↩️</span>ตีกลับ
        </Option>
      </>
    );
  };

  useEffect(() => {
    const DataLoad = {
      userId: userId, // เบลโหลดกลับมาเปลี่ยนเป็น user
      currentStatus: 1,
    };

    loadMainData(DataLoad);
  }, []);

  const handleLoad = (data) => {
    console.log(data);

    const DataLoad = {
      userId: userId, // เบลโหลดกลับมาเปลี่ยนเป็น user
      currentStatus: searchSelect,
    };

    loadMainData(DataLoad);
    setTitelColumn(searchSelect);
  };

  const filterData = (data) => {
    if (data) {
      console.log("5.filterData");
      const useData = sortByRelationFollow(data);
      setArrayTable(useData);
      setDataArr(useData);
      setAdvanceSearch(true);
    } else {
      console.error("data is not an array or is undefined");
      setArrayTable(null);
      setDataArr(null);
      setAdvanceSearch(false);
    }
  };

  function sortByRelationFollow(arr) {
    // 1) แยกเป็นกลุ่มตาม contno (จะได้ไม่ปนข้ามสัญญา)
    const groups = arr.reduce((m, it) => {
      const k = it.contno ?? it.loanId ?? "_";
      (m[k] ??= []).push(it);
      return m;
    }, {});

    const result = [];

    // 2) จัดแต่ละกลุ่ม
    for (const key of Object.keys(groups)) {
      const group = groups[key];

      // followerMap: parentCustomerId -> [followers...]
      const followerMap = new Map();
      for (const it of group) {
        if (it.garno === 0 && it.relationCustomerId != null) {
          const list = followerMap.get(it.relationCustomerId) || [];
          list.push(it); // เก็บตามลำดับเดิม
          followerMap.set(it.relationCustomerId, list);
        }
      }

      // 3) สร้างลำดับใหม่แบบคงความเป็น original order ให้มากที่สุด
      const placed = new Set(); // customerId ที่วางแล้ว

      // ฟังก์ชันช่วย: วางตัวหลัก + ตามด้วยลูก ๆ ที่อ้างถึงเขา
      const placeWithFollowers = (parent) => {
        if (placed.has(parent.customerId)) return;
        result.push(parent);
        placed.add(parent.customerId);

        const followers = followerMap.get(parent.customerId) || [];
        for (const f of followers) {
          if (!placed.has(f.customerId)) {
            result.push(f);
            placed.add(f.customerId);
          }
        }
      };

      // 3.1 วางตัวหลัก (ไม่ใช่ follower ภายในกลุ่ม)
      for (const it of group) {
        const isFollower =
          it.garno === 0 &&
          it.relationCustomerId != null &&
          group.some((x) => x.customerId === it.relationCustomerId); // มีพ่อในกลุ่ม
        if (!isFollower) {
          placeWithFollowers(it);
        }
      }

      // 3.2 วางที่เหลือ (เผื่อกรณี orphan หรือ relation อยู่นอกกลุ่ม)
      for (const it of group) {
        if (!placed.has(it.customerId)) {
          placeWithFollowers(it);
        }
      }
    }

    return result;
  }

  const handleFilterData = () => {
    setLoading(true);
    const rows = Array.isArray(dataArr) ? dataArr : [];
    const norm = (v) =>
      String(v ?? "")
        .trim()
        .toLowerCase();

    const sameDay = (a, b) =>
      !!a &&
      !!b &&
      dayjs(a).format("YYYY-MM-DD") === dayjs(b).format("YYYY-MM-DD");

    const inRange = (dt, [from, to]) => {
      if (!dt || !from || !to) return false;
      const ts = dayjs(dt).valueOf();
      const s = dayjs(from).startOf("day").valueOf();
      const e = dayjs(to).endOf("day").valueOf();
      return ts >= s && ts <= e;
    };

    const q = norm(searchInputTable); // ข้อความค้นหา
    const dateSel = datePickerTable;

    const result = rows.filter((item) => {
      const passQuery =
        !q ||
        [
          item.CUSCOD,
          item.CONTNO, // เพิ่มสำหรับข้อมูลของคุณ
          item.NAME1, // เพิ่มชื่อ
          item.NAME2, // เพิ่มนามสกุล
        ]
          .map(norm)
          .some((val) => val.includes(q));

      // 2) วันที่ (รองรับทั้งวันเดียวและช่วงวันที่)
      let passDate = true;
      if (dateSel) {
        const dateToCheck = item.datetime || item.dateOnlineInvestigate;
        passDate =
          Array.isArray(dateSel) && dateSel.length === 2
            ? inRange(dateToCheck, dateSel)
            : sameDay(dateToCheck, dateSel);
      }

      return passQuery && passDate;
    });

    setArrayTable(result);

    setTimeout(() => {
      setLoading(false);
    }, 250);

    if (result.length === 0) {
      message.error("ไม่พบข้อมูล");
    } else {
      message.success(`พบข้อมูล ${result.length} รายการ`);
    }
  };

  const handleCreatePDF = () => {
    generateLawsuitListPDF({
      dataList: arrayTable, // Array จาก API
      convertDateThai, // ฟังก์ชันแปลงวันที่ที่ใช้อยู่
    });
  };

  // Function เปิด Modal
  const confirmAcceptWork = (record) => {
    console.log("confirmAcceptWork");

    setDataRecord(record);
    setIsModalMemoCheckDoc(true);
  };

  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: "10%",
      render: (text, object, key) => key + 1,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      render: (text, record) => <>{record.CONTNO}</>,
    },
    {
      title: "ชื่อ-กสุล",
      dataIndex: "date Send",
      key: "dateSend",
      align: "center",
      render: (text, record) => (
        <>
          {`${record.SNAM}${record.NAME1} ${record.NAME2 ? record.NAME2 : ""}`}
        </>
      ),
    },

    {
      title: (() => {
        const titleMap = {
          1: "แจ้งส่งฟ้องเมื่อ",
          2: "รับงานเมื่อ",
          3: "เตรียมสำเร็จเมื่อ",
          6: "ตีกลับเมื่อ",
        };
        return titleMap[titelColumn] || "-";
      })(),
      dataIndex: "ceoSend",
      key: "ceoSend",
      align: "center",
      render: (text, record) => {
        // ✅ เลือก field ตาม searchSelect
        const dateFieldMap = {
          1: record.ceoSend,
          2: record.acceptDoc,
          3: record.completeCheckDoc,
          6: record.failDoc,
        };

        const dateValue = dateFieldMap[titelColumn];

        if (!dateValue) {
          return <Tag color="white">-</Tag>;
        }

        const isOverdue = dayjs(dateValue).isAfter(dayjs().add(7, "day"));

        return (
          <Tag color={isOverdue ? "red" : "blue"}>
            {dayjs(dateValue).add(543, "year").format("D MMM YY")}
          </Tag>
        );
      },
    },
    {
      title: "วันที่ดำเนินการ",
      align: "center",
      render: (text, record) => {
        const statusConfig = {
          1: {
            field: record.acceptDocAd,
            label: "ธรุการรับงาน",
            color: "blue",
          },
          2: {
            field: record.completeCheckDocAd,
            label: "ธรุการเตรียมสำเร็จ",
            color: "green",
          },
        };

        const config = statusConfig[record.currentStatusAd];

        if (!config || !config.field) {
          return <Tag color="default">-</Tag>;
        }

        return (
          <div>
            <Tag color={config.color} style={{ textAlign: "center" }}>
              {config.label}
              <br />
              {dayjs(config.field).add(543, "year").format("D MMM YY")}
            </Tag>
          </div>
        );
      },
    },
    {
      title: "สถานะ",
      align: "center",
      render: (record) => (
        <Tag
          color={
            record.loanActive === 1
              ? record.currentStatus === 1
                ? "red"
                : record.currentStatus === 2
                  ? "blue"
                  : record.currentStatus === 3
                    ? "green"
                    : record.currentStatus === 1 && record.currentStatusAd === 3
                      ? "orange"
                      : "default"
              : "default"
          }
        >
          {record.loanActive === 1
            ? record.currentStatus === 1 && record.currentStatusAd === 0
              ? "รอธรุการรับงาน"
              : record.currentStatus === 1 && record.currentStatusAd === 1
                ? "ธรุการดำเนินงาน"
                : record.currentStatus === 1 && record.currentStatusAd === 2
                  ? "พร้อมรับงาน"
                  : record.currentStatus === 1 && record.currentStatusAd === 3
                    ? "ตีกลับให้ธุรการ"
                    : record.currentStatus === 2
                      ? "รอดำเนินการ"
                      : record.currentStatus === 3
                        ? "เตรียมเอกสารแล้ว"
                        : record.currentStatus === 6
                          ? "ตีกลับ"
                          : "-"
            : "ปิดสัญญาแล้ว"}
        </Tag>
      ),
    },
    {
      title: "การจัดการ",
      align: "center",
      render: (record) => {
        const actions = {
          1: {
            color: "red",
            label: "📥 รับงาน",
            onClick: () => {
              console.log(record);
              confirmAcceptWork(record);
            },
          },
          2: {
            color: "blue",
            icon: <FileSearchOutlined />,
            label: "เตรียมเอกสาร",
            onClick: () => {
              console.log(record);
              setDataRecord(record);
              setIsModalCheckDoc(true);
            },
          },
          3: {
            color: "orange",
            icon: <EditOutlined />,
            label: "แก้ไข",
            onClick: () => {
              console.log(record);
              setDataRecord(record);
              setIsModalCheckDoc(true);
            },
          },
          6: {
            color: "orange",
            icon: <EditOutlined />,
            label: "แก้ไข",
            onClick: () => {
              console.log(record);
              setDataRecord(record);
              setIsModalCheckDoc(true);
            },
          },
        };

        const action = actions[record.currentStatus];
        // if (record.currentStatusAd === 2) return null;

        return (
          <Button
            color={action.color}
            variant="outlined"
            onClick={action.onClick}
            disabled={record.currentStatusAd !== 2 || record.loanActive === 0}
          >
            {action.icon} {action.label}
          </Button>
        );
      },
    },
  ];

  return (
    <>
      <Card>
        <Row>
          <Col span={"12"} style={{ textAlign: "start" }}>
            <Tooltip
              title={advanceSearch ? "ซ่อนตัวกรอง" : "แสดงตัวกรอง"}
              arrow={mergedArrow}
            >
              {advanceSearch ? (
                <DownSquareOutlined
                  style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                  onClick={toggle} // antd ส่งค่า checked มาให้
                />
              ) : (
                <UpSquareOutlined
                  style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                  onClick={toggle} // antd ส่งค่า checked มาให้
                />
              )}
            </Tooltip>
            <Space direction="horizontal" size={8}>
              <Select
                size="large"
                style={{ minWidth: "auto", marginRight: 8 }}
                placeholder="เลือกการค้นหา"
                popupMatchSelectWidth={false}
                value={searchSelect}
                onChange={(value) => setSearchSelect(value)}
                showSearch
                optionFilterProp="label"
              >
                {renderOpteionSearch()}
              </Select>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                size="large"
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  fontWeight: "bold",
                  background: "linear-gradient(135deg, #667eea, blue)",
                  border: "none",
                  marginLeft: 5,
                }}
                onClick={handleLoad}
                disabled={loading}
              >
                ค้นหา
              </Button>
              <Button
                icon={<ReloadOutlined />}
                onClick={() => {
                  setSearchInputTable(null);
                }}
                color="red"
                variant="outlined"
              >
                ล้าง
              </Button>
            </Space>
          </Col>
          {searchSelect === 1 && (
            <Col span={"12"} style={{ textAlign: "end" }}>
              <Button
                icon={<FilePdfOutlined />}
                onClick={() => {
                  handleCreatePDF();
                }}
                color="red"
                variant="outlined"
              >
                export
              </Button>
            </Col>
          )}
        </Row>
      </Card>

      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Row>
            {advanceSearch ? (
              <Row>
                <Col
                  span={24}
                  style={{ textAlign: "start", marginBottom: "10px" }}
                >
                  <Space size={10} wrap>
                    <ThaiRangePicker
                      value={datePickerTable}
                      onChange={setDatePickerTable}
                      size="large"
                    />
                    <Input
                      placeholder="ค้นหาสัญญาในตาราง"
                      value={searchInputTable}
                      onChange={(e) => setSearchInputTable(e.target.value)} // เก็บค่าที่พิมพ์
                      style={{
                        width: "auto",
                        borderRadius: "8px",
                      }}
                      size="small"
                      suffix={<span style={{ marginRight: 5 }}>🔍</span>}
                    />

                    <Button
                      icon={<FilterOutlined />}
                      size="large"
                      style={{
                        borderRadius: 8,
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        fontWeight: "bold",
                        backgroundColor: "#fff7d6",
                        color: "#333",
                        border: "1px solid #ffe58f",
                      }}
                      onClick={() => handleFilterData()}
                      disabled={dataArr.length === 0}
                    >
                      กรองข้อมูล
                    </Button>
                    <Button
                      icon={<ReloadOutlined />}
                      onClick={() => {
                        setDatePickerTable(null);
                        setSearchInputTable(null);
                        setArrayTable(dataArr);
                      }}
                      color="red"
                      variant="outlined"
                      disabled={dataArr.length === 0}
                    >
                      ล้าง
                    </Button>
                  </Space>
                </Col>
              </Row>
            ) : null}
            <Col span={"24"}>
              <Table
                size="small"
                columns={columns}
                dataSource={arrayTable}
                scroll={{ x: 850 }}
                footer={() => (
                  <div
                    style={{
                      alignItems: "center",
                    }}
                  >
                    <p style={{ margin: 0 }}>
                      จำนวนสัญญาทั้งหมด {arrayTable?.length}
                    </p>
                  </div>
                )}
              />
            </Col>
          </Row>
        </Spin>
      </Card>
      {isModalCheckDoc ? (
        <CheckingDocuments
          open={isModalCheckDoc}
          close={setIsModalCheckDoc}
          dataDefault={dataRecord}
          func={handleLoad}
          status={searchSelect}
        />
      ) : null}
      {isModalMemoCheckDoc && (
        <MemoCheckDoc
          open={isModalMemoCheckDoc}
          close={setIsModalMemoCheckDoc}
          record={dataRecord}
          handleLoad={handleLoad}
          status={searchSelect}
        />
      )}
    </>
  );
};

const MainCheckDocument = MotionHoc(Main);
export default MainCheckDocument;
